<div
  class="chip-option-group__chips"
  role="presentation">
  <ng-content></ng-content>
</div>
